import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { map, isEmpty, isFunction } from 'lodash';

import { Roles } from '@services/http';
import useHttp from '@hooks/useHttp';
import { AutoComplete } from '..';

const UserPermissions = ({ initialValues, handleValues, role }) => {
  const [availablePermissions, setAvailablePermissionsData] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState(initialValues);

  useHttp({
    endpoint: () => Roles.getPermissions(),

    deps: [role],
    cb: (value) => {
      setAvailablePermissionsData(value.data);
    },
  });

  useEffect(() => {
    const names = map(selectedPermissions, 'name');
    isFunction(handleValues) && handleValues('permissions', names);
  }, [handleValues, selectedPermissions]);

  return isEmpty(role) || isEmpty(availablePermissions) ? null : (
    <Grid item md={6} xs={12}>
      <AutoComplete
        showKey="label"
        placeholder="permissions"
        data={availablePermissions}
        selected={selectedPermissions}
        handleSelected={setSelectedPermissions}
      />
    </Grid>
  );
};

UserPermissions.defaultProps = {
  initialValues: [],
};

UserPermissions.propTypes = {
  initialValues: PropTypes.array,
  handleValues: PropTypes.func.isRequired,
  role: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default UserPermissions;
